import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';

@Component({
  selector: 'form-atividade-nota',
  templateUrl: 'form-atividade-nota.html',
  styleUrls: ['form-atividade-nota.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    FormAtividadeNotaComponent,
    NomenclaturaPipe,
  ],
})
export class FormAtividadeNotaComponent {
  validations_form: FormGroup;
  @Input()
  atividade: any;

  constructor(public formBuilder: FormBuilder) {
    this.validations_form = this.formBuilder.group({
      nome: new FormControl(null, Validators.required),
      nota: new FormControl(null, Validators.nullValidator),
    });

    setTimeout(() => {
      this.atividade.nota /= 100;
    }, 1000);
  }

  counter(i: number) {
    return new Array(i);
  }
}
